import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _class, _class2, _NextIcon, _NextIcon2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import classNames from 'classnames';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import LoadingBar from 'react-redux-loading-bar';
import NextIcon from '@mui/icons-material/NavigateNext';
import DoneIcon from '@mui/icons-material/CheckCircle';
import SpeakerNotes from '@mui/icons-material/SpeakerNotes';
import SpeakerNotesOff from '@mui/icons-material/SpeakerNotesOff';
import { withCookies, Cookies } from 'react-cookie';
import { createEditorState } from 'medium-draft';
import { NoSsr } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import AppContext from '../../context';
import Link from '../../components/Link';
import Intercom from '../../widgets/Intercom';
import history from '../../history';
import CongratulationsModal from './CongratulationsModal/CongratulationsModal';
import SkillEvaluationModal from './SkillEvaluationModal/SkillEvaluationModal';
import LessonReviewModal from './LessonReviewModal/LessonReviewModal';
import LessonHeader from './LessonHeader/LessonHeader';
import Audio from './Audio/Audio';
import Text from './Text/Text';
import Video from './Video/Video';
import s from './LessonDetails.scss';
import {
// buildQuery,
hasMedicalLicense, getImagesFromDraftJS, isTrial, isSupportAdminAuth } from '../../helpers';
import isMobileUserAgent from '../../helpers/checkMobileUserAgent';
import isLoggedIn from '../../helpers/checkAuth';
import * as lessonDetailsActions from '../../actions/lessonDetails';
import * as courseDetailsActions from '../../actions/courseDetails';
import { getCourseReview } from '../../actions/courseReview';
import messages from './lessonDetailsMessages';
import decorators from './Text/decorators';
import AttachedCoursesModal from './AttachedCoursesModal/AttachedCoursesModal';
import GoToNextSection from './GoToNextSection/GoToNextSection';
import intlPropTypes from '../../constants/intlPropTypes';
var getNextUrl = function getNextUrl(nextItem) {
  if (!nextItem) {
    return undefined;
  }
  if (nextItem.itemType === 'Lesson') {
    return "lessons/".concat(nextItem.item.slug);
  }
  if (nextItem.itemType === 'Quiz') {
    return "quizzes/".concat(nextItem.item._id);
  }
  return '';
};
var getNextPath = function getNextPath(courseSlug, nextUrl) {
  return nextUrl ? "/courses/".concat(courseSlug, "/").concat(nextUrl) : "/courses/".concat(courseSlug);
};
var LessonDetails = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    auth: state.auth,
    lesson: state.lessonDetails.lesson,
    textNotes: state.lessonDetails.textNotes,
    loadingTextNotes: state.lessonDetails.loadingTextNotes,
    isPlayerLoaded: state.lessonDetails.isPlayerLoaded,
    isNotesShown: state.lessonDetails.isNotesShown,
    videoNotes: state.lessonDetails.videoNotes,
    completed: state.lessonDetails.completed,
    course: state.courseDetails.course,
    transcodingJobs: state.transcodingJobs.jobs,
    totalTranscodingJobs: state.transcodingJobs.total,
    lang: state.intl.locale,
    completeLessonError: state.lessonDetails.error
  };
}, function (dispatch) {
  return bindActionCreators({
    getLessonTextNotes: lessonDetailsActions.getLessonTextNotes,
    updateState: lessonDetailsActions.updateState,
    completeLesson: lessonDetailsActions.completeLesson,
    resetCompletedLesson: lessonDetailsActions.resetCompletedLesson,
    getCourseBySlug: courseDetailsActions.getCourseBySlug,
    resetVideoNotes: lessonDetailsActions.resetVideoNotes,
    resetTextNotes: lessonDetailsActions.resetTextNotes,
    getCourseReview: getCourseReview
  }, dispatch);
}), injectIntl(_class = withCookies(_class = _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(LessonDetails, _React$Component);
  var _super = _createSuper(LessonDetails);
  function LessonDetails(props) {
    var _this;
    _classCallCheck(this, LessonDetails);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "setAudioEnded", function (isAudioEnded) {
      _this.setState({
        isAudioEnded: isAudioEnded
      });
    });
    _defineProperty(_assertThisInitialized(_this), "afterPrint", function () {
      _this.setState({
        contentTypeSwitchers: _objectSpread({}, _this.oldContentTypeSwitchers)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "beforePrint", function () {
      var contentTypeSwitchers = _this.state.contentTypeSwitchers;
      _this.oldContentTypeSwitchers = _objectSpread({}, contentTypeSwitchers);
      if (!contentTypeSwitchers.text) {
        contentTypeSwitchers.text = true;
        _this.setState({
          contentTypeSwitchers: contentTypeSwitchers
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateNavBar", function () {
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    });
    _defineProperty(_assertThisInitialized(_this), "handleChangeVideoFullPage", function (videoFullPage) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return null;
      };
      return _this.setState({
        videoFullPage: videoFullPage
      }, cb);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleNotes", function () {
      var _this$props = _this.props,
        isNotesShown = _this$props.isNotesShown,
        updateState = _this$props.updateState;
      if (_this.updateTextNotes) {
        _this.updateTextNotes(!isNotesShown);
      }
      if (_this.updateVideoNotes) {
        _this.updateVideoNotes(!isNotesShown);
      }
      updateState('isNotesShown', !isNotesShown);
    });
    _defineProperty(_assertThisInitialized(_this), "switchContentType", function (type) {
      var _this$state = _this.state,
        contentTypeSwitchers = _this$state.contentTypeSwitchers,
        isTextContentSwitcherDisabled = _this$state.isTextContentSwitcherDisabled;
      var _this$props2 = _this.props,
        lesson = _this$props2.lesson,
        cookies = _this$props2.cookies;
      var newTypeState = !contentTypeSwitchers[type];
      //
      // if (type === 'audio' && !_.get(lesson, 'videos.length')) {
      //   return;
      // }

      if (type === 'text' && contentTypeSwitchers.audio) {
        return;
      }
      var newContentTypeSwitchers = _objectSpread(_objectSpread({}, contentTypeSwitchers), {}, _defineProperty({}, type, newTypeState));
      if (type === 'video' && !contentTypeSwitchers.text && contentTypeSwitchers.video) {
        return;
      }
      if (type === 'video' && !_.get(lesson, 'audios.length') && contentTypeSwitchers.video) {
        newContentTypeSwitchers.text = true;
      }
      if (type === 'video') {
        newContentTypeSwitchers.audio = !newTypeState && !!_.get(lesson, 'audios.length');
        newContentTypeSwitchers.text = true;
      }
      if (type === 'audio') {
        newContentTypeSwitchers.video = !newTypeState && !!_.get(lesson, 'videos.length');
        newContentTypeSwitchers.text = true;
      }
      if (isTextContentSwitcherDisabled && !newContentTypeSwitchers.audio) {
        newContentTypeSwitchers.text = false;
      }
      if (!newContentTypeSwitchers.audio && !newContentTypeSwitchers.text && !newContentTypeSwitchers.video && isTextContentSwitcherDisabled && contentTypeSwitchers.audio) {
        return;
      }
      if (!newContentTypeSwitchers.audio && !newContentTypeSwitchers.text && !newContentTypeSwitchers.video) {
        newContentTypeSwitchers.text = true;
      }
      var newState = {
        contentTypeSwitchers: newContentTypeSwitchers
      };
      if (contentTypeSwitchers.video && !newContentTypeSwitchers.video && _this.player) {
        newState.playFrom = _this.player.currentTime();
      }
      _this.setState(newState, function () {
        if (_.get(_assertThisInitialized(_this), 'player.resizeVideoJS')) {
          _this.player.resizeVideoJS();
        }
        if (!contentTypeSwitchers.video && newContentTypeSwitchers.video && _this.player && newState.playFrom) {
          _this.player.currentTime(newState.playFrom);
        }
      });
      cookies.set('contentTypeSwitchers', newContentTypeSwitchers, {
        path: '/',
        domain: window.App.cookieDomain
      });
    });
    _defineProperty(_assertThisInitialized(_this), "complete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props3, lessonId, _this$props3$course, courseId, courseSlug, completeLesson, getCourseBySlug, auth, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props3 = _this.props, lessonId = _this$props3.lesson._id, _this$props3$course = _this$props3.course, courseId = _this$props3$course._id, courseSlug = _this$props3$course.slug, completeLesson = _this$props3.completeLesson, getCourseBySlug = _this$props3.getCourseBySlug, auth = _this$props3.auth;
            if (!(!courseId || !isLoggedIn(auth))) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", true);
          case 3:
            _context.next = 5;
            return completeLesson({
              lessonId: lessonId,
              courseId: courseId,
              courseSlug: courseSlug
            });
          case 5:
            result = _context.sent;
            if (!_.get(result, 'error')) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", false);
          case 8:
            _context.next = 10;
            return getCourseBySlug(courseSlug);
          case 10:
            return _context.abrupt("return", true);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "closeCongratulationsModal", function () {
      _this.setState({
        isCongratulationsModalOpened: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeEvaluationModal", function () {
      _this.setState({
        isEvaluationModalOpened: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleLessonReviewContent", function (showLessonReviewModal) {
      _this.setState({
        showLessonReviewModal: showLessonReviewModal
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeCompletedLessonModal", function () {
      var _this$props4 = _this.props,
        completeLessonError = _this$props4.completeLessonError,
        resetCompletedLesson = _this$props4.resetCompletedLesson;
      _this.setState({
        errorSnackbarMsg: _.get(completeLessonError, 'message', '')
      });
      resetCompletedLesson();
    });
    _defineProperty(_assertThisInitialized(_this), "handleCloseErrorSnackbar", function () {
      _this.setState({
        errorSnackbarMsg: ''
      });
    });
    _defineProperty(_assertThisInitialized(_this), "logSearchSessionLessonOpened", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props5, lesson, searchSessionId, auth;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this$props5 = _this.props, lesson = _this$props5.lesson, searchSessionId = _this$props5.searchSessionId, auth = _this$props5.auth;
            if (!(!searchSessionId || !isLoggedIn(auth))) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return _this.context.fetch("/api/courses/search-session/".concat(searchSessionId, "/log-item"), {
              method: 'PATCH',
              body: JSON.stringify({
                lessonIdOpenedBySearch: lesson === null || lesson === void 0 ? void 0 : lesson._id
              })
            });
          case 6:
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](3);
            console.error(_context2.t0);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 8]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "openAttachedCoursesByUsersModal", function () {
      _this.setState({
        isAttachedCoursesByUsersModalOpened: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeAttachedCoursesByUsersModal", function () {
      _this.setState({
        isAttachedCoursesByUsersModalOpened: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "goToNextAudioLesson", function () {
      var _this$state2 = _this.state,
        goToNextSectionItemProgress = _this$state2.goToNextSectionItemProgress,
        nextItem = _this$state2.nextItem,
        nextPath = _this$state2.nextPath;
      if (!nextItem || !nextPath) return;
      if (goToNextSectionItemProgress !== 0) return;
      var timeout = 7000;
      var startTs = Date.now();
      _this.intervalTimer = setInterval(function () {
        var progress = (Date.now() - startTs) / timeout * 100;
        if (progress > 100) {
          clearInterval(_this.intervalTimer);
          return;
        }
        _this.setState({
          goToNextSectionItemProgress: progress
        });
      }, 20);
      _this.timeoutTimer = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.loadNextItem();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })), timeout);
    });
    _defineProperty(_assertThisInitialized(_this), "cancelGoToNextSectionItem", function () {
      clearTimeout(_this.timeoutTimer);
      clearInterval(_this.intervalTimer);
      _this.setState({
        goToNextSectionItemProgress: 0
      });
    });
    _defineProperty(_assertThisInitialized(_this), "loadNextItem", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _this$state3, nextItem, nextPath;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _this$state3 = _this.state, nextItem = _this$state3.nextItem, nextPath = _this$state3.nextPath;
            _this.cancelGoToNextSectionItem();
            if (!(!nextItem || !nextPath)) {
              _context4.next = 4;
              break;
            }
            return _context4.abrupt("return");
          case 4:
            if (history) {
              history.push(nextPath);
            }
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    _defineProperty(_assertThisInitialized(_this), "updateSubtitleSettings", function (settings) {
      return _this.context.fetch('/api/auth', {
        method: 'PUT',
        body: JSON.stringify(settings)
      })["catch"](function (err) {
        console.error(err);
      });
    });
    _this.completePromise = null;
    _this.completeOnce = function () {
      if (!_this.completePromise) {
        _this.completePromise = Promise.resolve(_this.complete()).then(function (isCompleted) {
          if (!isCompleted) _this.completePromise = null;
          return isCompleted;
        })["catch"](function (error) {
          _this.completePromise = null;
          throw error;
        });
      }
      return _this.completePromise;
    };
    var course = props.course,
      query = props.query;
    var lessonsAndQuizzes = _(course && course.sections || []).filter(function (item) {
      return !item.isContentHidden;
    }).map('items').flatten().value();
    var lessonIndex = _.findIndex(lessonsAndQuizzes, function (item) {
      return item.item._id === _.get(_assertThisInitialized(_this), 'props.lesson._id');
    });
    var _nextItem = lessonsAndQuizzes[lessonIndex + 1];
    var nextUrl = getNextUrl(_nextItem);
    _this.state = {
      isCongratulationsModalOpened: false,
      isAttachedCoursesByUsersModalOpened: false,
      showLessonReviewModal: false,
      isAudioEnded: false,
      errorSnackbarMsg: '',
      isEvaluationModalOpened: _.has(query, 'showEvaluationModal') && !isSupportAdminAuth(props.auth),
      nextItem: _nextItem,
      nextUrl: nextUrl,
      nextPath: _nextItem && getNextPath(course.slug, nextUrl),
      goToNextSectionItemProgress: 0
    };
    var _contentTypeSwitchers = _.assign({
      video: true,
      audio: false,
      text: true
    }, _this.props.cookies.get('contentTypeSwitchers'));
    if (!_.get(props, 'lesson.videos.length') && !_.get(props, 'totalTranscodingJobs') && !_.get(props, 'lesson.youtubeVideoUrl')) {
      _contentTypeSwitchers.video = false;
      _contentTypeSwitchers.text = true;
      _contentTypeSwitchers.audio = true;
    }
    if (!_.get(props, 'lesson.audios.length')) {
      _contentTypeSwitchers.audio = false;
    }
    if (_.get(props, 'lesson.audios.length') || _.get(props, 'lesson.youtubeVideoUrl') || _.get(props, 'lesson.videos.length')) {
      var editorState = createEditorState(_.get(props, 'lesson.content'), decorators);
      var editorStateContent = editorState && editorState.getCurrentContent();
      var imageContent = getImagesFromDraftJS(_.get(props, 'lesson.content'));
      var isTextExist = editorStateContent && editorStateContent.hasText() && !!editorStateContent.getPlainText().trim().length || !!_.get(imageContent, 'length');
      if (!isTextExist) {
        _this.state.isTextContentSwitcherDisabled = true;
        if (!_contentTypeSwitchers.audio) {
          _contentTypeSwitchers.text = false;
        }
      }
    }
    _this.state.contentTypeSwitchers = _contentTypeSwitchers;
    _this.state.videoFullPage = _this.props.isIOS || _this.props.lesson.youtubeVideoUrl || _this.props.totalTranscodingJobs && !_.get(_this.props.lesson, 'videos.length') ? false : !_this.props.cookies.get('contentTypeSwitchers') && _contentTypeSwitchers.video;
    return _this;
  }
  _createClass(LessonDetails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.state.videoFullPage && !isMobileUserAgent()) {
        Intercom.boot(this.props.auth.user, this.context.whitelabeling);
      } else {
        Intercom.hideWidget();
      }
      this.updateNavBar();
      if (_.get(this, 'props.course._id') && isLoggedIn(this.props.auth)) {
        this.props.getCourseReview(_.get(this, 'props.course._id'));
      }
      window.addEventListener('resize', this.updateNavBar);
      window.addEventListener('afterprint', this.afterPrint);
      window.addEventListener('beforeprint', this.beforePrint);
      this.logSearchSessionLessonOpened();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (_.get(this, 'props.lesson._id') !== _.get(nextProps, 'lesson._id')) {
        this.completePromise = null;
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.playFrom = 0;
        var lessonsAndQuizzes = _(_.get(nextProps, 'course.sections', [])).filter(function (item) {
          return !item.isContentHidden;
        }).map('items').flatten().value();
        var lessonIndex = _.findIndex(lessonsAndQuizzes, function (item) {
          return item.item._id === _.get(nextProps, 'lesson._id');
        });
        var nextItem = lessonsAndQuizzes[lessonIndex + 1];
        var nextUrl = getNextUrl(nextItem);
        var contentTypeSwitchers = _.assign({
          video: true,
          audio: false,
          text: true
        }, nextProps.cookies.get('contentTypeSwitchers'));
        if (!_.get(nextProps, 'lesson.videos.length') && !_.get(nextProps, 'totalTranscodingJobs') && !_.get(nextProps, 'lesson.youtubeVideoUrl')) {
          contentTypeSwitchers.video = false;
          contentTypeSwitchers.text = true;
          contentTypeSwitchers.audio = true;
        }
        if (!_.get(nextProps, 'lesson.audios.length')) {
          contentTypeSwitchers.audio = false;
        }
        var isTextContentSwitcherDisabled = false;
        if (_.get(nextProps, 'lesson.audios.length') || _.get(nextProps, 'lesson.youtubeVideoUrl') || _.get(nextProps, 'lesson.videos.length')) {
          var editorState = createEditorState(_.get(nextProps, 'lesson.content'), decorators);
          var editorStateContent = editorState && editorState.getCurrentContent();
          var imageContent = getImagesFromDraftJS(_.get(nextProps, 'lesson.content'));
          var isTextExist = editorStateContent && editorStateContent.hasText() && !!editorStateContent.getPlainText().trim().length || !!_.get(imageContent, 'length');
          if (!isTextExist) {
            isTextContentSwitcherDisabled = true;
            if (!contentTypeSwitchers.audio) {
              contentTypeSwitchers.text = false;
            }
          }
        }
        this.setState({
          isTextContentSwitcherDisabled: isTextContentSwitcherDisabled,
          videoFullPage: false,
          showLessonReviewModal: false,
          isAudioEnded: false,
          nextItem: nextItem,
          nextUrl: nextUrl,
          nextPath: nextItem && getNextPath(_.get(nextProps, 'course.slug'), nextUrl),
          contentTypeSwitchers: contentTypeSwitchers
        });
      }
      if (_.get(this, 'props.course._id') === _.get(nextProps, 'course._id') && (_.get(this, 'props.course.progress') !== 100 && _.get(nextProps, 'course.progress')) === 100) {
        this.setState({
          isCongratulationsModalOpened: true
        });
        _.invoke(this.player, 'pause');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.completeLessonError && _.get(this.props, 'completeLessonError.message') !== _.get(prevProps, 'completeLessonError.message')) {
        this.closeCompletedLessonModal();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateNavBar);
      window.removeEventListener('afterprint', this.afterPrint);
      window.removeEventListener('beforeprint', this.beforePrint);
      this.props.resetVideoNotes();
      this.props.resetTextNotes();
      this.cancelGoToNextSectionItem();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props6 = this.props,
        auth = _this$props6.auth,
        lesson = _this$props6.lesson,
        course = _this$props6.course,
        loadingTextNotes = _this$props6.loadingTextNotes,
        updatingTextNotes = _this$props6.updatingTextNotes,
        isNotesShown = _this$props6.isNotesShown,
        query = _this$props6.query,
        totalTranscodingJobs = _this$props6.totalTranscodingJobs,
        formatMessage = _this$props6.intl.formatMessage,
        posterVimeo = _this$props6.posterVimeo;
      var completed = this.props.completed;
      var _this$state4 = this.state,
        contentTypeSwitchers = _this$state4.contentTypeSwitchers,
        videoFullPage = _this$state4.videoFullPage,
        nextItem = _this$state4.nextItem,
        nextUrl = _this$state4.nextUrl,
        nextPath = _this$state4.nextPath,
        isCongratulationsModalOpened = _this$state4.isCongratulationsModalOpened,
        isEvaluationModalOpened = _this$state4.isEvaluationModalOpened,
        playFrom = _this$state4.playFrom,
        showLessonReviewModal = _this$state4.showLessonReviewModal,
        isAudioEnded = _this$state4.isAudioEnded,
        isTextContentSwitcherDisabled = _this$state4.isTextContentSwitcherDisabled,
        errorSnackbarMsg = _this$state4.errorSnackbarMsg,
        isAttachedCoursesByUsersModalOpened = _this$state4.isAttachedCoursesByUsersModalOpened,
        goToNextSectionItemProgress = _this$state4.goToNextSectionItemProgress;
      var noNotesYet = !_.get(this, 'props.textNotes.length') && !_.get(this, 'props.videoNotes.length');
      var showNotes = contentTypeSwitchers.text && _.get(this, 'props.textNotes.length') || contentTypeSwitchers.video && _.get(this, 'props.videoNotes.length');
      var notesBtnTooltipTitle;
      if (isNotesShown) {
        notesBtnTooltipTitle = /*#__PURE__*/React.createElement(FormattedMessage, messages.hideNotesTitle);
      } else if (noNotesYet) {
        notesBtnTooltipTitle = /*#__PURE__*/React.createElement(FormattedMessage, messages.thereIsNoNotesYet);
      } else {
        notesBtnTooltipTitle = /*#__PURE__*/React.createElement(FormattedMessage, messages.showNotesTitle);
      }
      var attachedCoursesByUsers = _.get(this.props, 'lesson.attachedCoursesByUsers.length');
      var nextButtonDesktop = nextItem && (lesson.isCompleted || completed || !isLoggedIn(auth)) ? /*#__PURE__*/_jsx("span", {
        className: classNames(s.tabletFullWidth, s.goToButtonWrapper)
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.nextBtnTooltip, {
          name: _.get(nextItem, 'item.name', '')
        })
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "aria-label": formatMessage(messages.nextBtnTooltip, {
          name: _.get(nextItem, 'item.name', '')
        }),
        variant: "contained",
        color: "primary",
        to: nextPath,
        size: "large",
        "data-test": "next-btn",
        className: classNames(s.tabletFullWidth, s.goToButton),
        classes: {
          label: s.goToLabel
        },
        component: Link
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.nextBtnLabel), _NextIcon || (_NextIcon = /*#__PURE__*/_jsx(NextIcon, {}))))) : null;
      var nextButtonMobile = nextItem && (lesson.isCompleted || completed || !isLoggedIn(auth)) ? /*#__PURE__*/_jsx("div", {
        className: classNames(s.actionButtonWrapper, s.tabletFullWidth, s.goToButton)
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.nextBtnTooltip, {
          name: _.get(nextItem, 'item.name', '')
        })
      }, void 0, /*#__PURE__*/_jsx(Button, {
        variant: "contained",
        color: "primary",
        to: nextPath,
        size: "large",
        classes: {
          label: s.goToLabel
        },
        className: s.tabletFullWidth,
        component: Link
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.nextBtnLabel), _NextIcon2 || (_NextIcon2 = /*#__PURE__*/_jsx(NextIcon, {}))))) : null;
      var attachedCoursesBtn = isLoggedIn(auth) ? /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.attachedCoursesByUsersBtnTooltip)
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "8zboceS6XPDTQAW9G8JN4",
        "data-test": "attached-courses-button",
        variant: "contained",
        color: "primary",
        onClick: this.openAttachedCoursesByUsersModal
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.attachedCoursesByUsersBtn))) : null;
      var renderActionButtons = function renderActionButtons(className) {
        return /*#__PURE__*/_jsx("div", {
          className: className
        }, void 0, isLoggedIn(auth) && showNotes ? /*#__PURE__*/_jsx(Tooltip, {
          title: notesBtnTooltipTitle
        }, void 0, /*#__PURE__*/_jsx(Button, {
          "data-test-id": "5rTWxH-TScLZMiBOXbrxF",
          variant: "contained",
          size: "large",
          className: classNames(s.actionButtonWrapper, s.flexInline, s.notesBtn, noNotesYet ? s.withPointerEvents : undefined),
          onClick: noNotesYet ? null : _this2.toggleNotes,
          disabled: noNotesYet,
          component: "div"
        }, void 0, !isNotesShown && /*#__PURE__*/_jsx(SpeakerNotesOff, {
          className: s.buttonIcon
        }), isNotesShown && /*#__PURE__*/_jsx(SpeakerNotes, {
          className: s.buttonIcon
        }), /*#__PURE__*/React.createElement(FormattedMessage, messages.notesBtnTitle))) : null, course._id && isLoggedIn(auth) && /*#__PURE__*/_jsx("div", {
          className: classNames(s.actionButtonWrapper, s.statusBtn)
        }, void 0, /*#__PURE__*/_jsx(Button, {
          "data-test-id": "K9Xk-7Hcm65i7yrSp8X1c",
          variant: "contained",
          color: "primary",
          "data-tour": "complete-lesson-mobile",
          className: classNames(s.tabletFullWidth, _defineProperty({}, s.completeButtonSuccess, completed || lesson.isCompleted)),
          onClick: completed || lesson.isCompleted ? function () {
            return _this2.toggleLessonReviewContent(true);
          } : _this2.completeOnce,
          size: "large"
        }, void 0, (lesson.isCompleted || completed) && /*#__PURE__*/_jsx(DoneIcon, {
          className: s.buttonIcon
        }), completed || lesson.isCompleted ? /*#__PURE__*/React.createElement(FormattedMessage, messages.completedBtnMsg) : '', !lesson.isCompleted && !completed ? /*#__PURE__*/React.createElement(FormattedMessage, messages.completeBtnmsg) : '')), attachedCoursesBtn, nextButtonMobile);
      };
      return /*#__PURE__*/_jsx("div", {
        className: s.root
      }, void 0, /*#__PURE__*/_jsx(LoadingBar, {
        className: s.loadingBar
      }), isLoggedIn(auth) && /*#__PURE__*/_jsx(SkillEvaluationModal, {
        isOpen: isEvaluationModalOpened,
        onSave: this.closeEvaluationModal,
        courseId: course._id
      }), showLessonReviewModal && /*#__PURE__*/_jsx(LessonReviewModal, {
        closeLessonReviewContent: function closeLessonReviewContent() {
          return _this2.toggleLessonReviewContent(false);
        }
      }), /*#__PURE__*/_jsx("div", {
        className: classNames(s.appFrame, videoFullPage ? s.fullPage : undefined)
      }, void 0, (!!_.get(lesson, 'videos.length') || !!totalTranscodingJobs || lesson.youtubeVideoUrl) && videoFullPage && contentTypeSwitchers.video ? null : /*#__PURE__*/_jsx(LessonHeader, {
        switchContentType: this.switchContentType,
        contentTypeSwitchers: contentTypeSwitchers,
        isTextContentSwitcherDisabled: isTextContentSwitcherDisabled
      }), /*#__PURE__*/_jsx("main", {
        className: classNames(s.content, videoFullPage ? s.fullPage : undefined)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.lessonVideoAndTextContent
      }, void 0, contentTypeSwitchers.video && (!!_.get(lesson, 'videos.length') || totalTranscodingJobs || lesson.youtubeVideoUrl) && /*#__PURE__*/React.createElement(Video
      // key={lesson._id}
      , {
        complete: this.completeOnce,
        videoFullPage: videoFullPage,
        videoStop: isEvaluationModalOpened || showLessonReviewModal,
        handleChangeVideoFullPage: this.handleChangeVideoFullPage,
        contentTypeSwitchers: contentTypeSwitchers,
        nextUrl: nextUrl,
        nextPath: nextPath,
        nextItem: nextItem,
        query: query,
        playFrom: playFrom,
        thumbnailVimeoImg: posterVimeo,
        ref: function ref(_ref5) {
          _this2.player = _ref5 && _ref5.player;
          _this2.updateVideoNotes = _ref5 && _ref5.toggleNotes;
        },
        className: s.video,
        isLessonReviewFocused: showLessonReviewModal,
        key: "video-".concat(lesson._id),
        updateSubtitleSettings: this.updateSubtitleSettings
      }), contentTypeSwitchers.text && /*#__PURE__*/React.createElement(Text, {
        key: "text-".concat(lesson._id),
        complete: this.completeOnce,
        contentTypeSwitchers: contentTypeSwitchers,
        ref: function ref(_ref6) {
          _this2.updateTextNotes = _ref6 && _ref6.toggleNotes;
        },
        className: s.text
      }), renderActionButtons(classNames(s.mobileTabletButtonsContainer, s.visibleOnlyMobileLandscape))), contentTypeSwitchers.audio && !!_.get(lesson, 'audios.length') && /*#__PURE__*/_jsx(Audio, {
        complete: this.completeOnce,
        play: !showLessonReviewModal && !isAudioEnded && !isCongratulationsModalOpened && !isEvaluationModalOpened,
        setAudioEnded: this.setAudioEnded,
        goToNextLesson: this.goToNextAudioLesson
      }, "audio2-".concat(lesson._id)), /*#__PURE__*/_jsx("div", {
        className: classNames(s.mobileTabletButtonsContainer, s.notVisibleInMobileLandscape)
      }, void 0, attachedCoursesBtn, isLoggedIn(auth) && course._id && showNotes ? /*#__PURE__*/_jsx(Tooltip, {
        title: notesBtnTooltipTitle
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "1pP9FGFbpDvwFG-gGZEWH",
        variant: "contained",
        size: "large",
        className: classNames(s.actionButtonWrapper, s.flexInline, s.notesBtn, noNotesYet ? s.withPointerEvents : undefined),
        onClick: noNotesYet ? null : this.toggleNotes,
        disabled: noNotesYet || updatingTextNotes || loadingTextNotes,
        component: "div"
      }, void 0, !isNotesShown && /*#__PURE__*/_jsx(SpeakerNotesOff, {
        className: s.buttonIcon
      }), isNotesShown && /*#__PURE__*/_jsx(SpeakerNotes, {
        className: s.buttonIcon
      }), /*#__PURE__*/React.createElement(FormattedMessage, messages.notesBtnTitle))) : null, isLoggedIn(auth) && course._id && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "OkRZT-GoqgFp-R0EtiL8k",
        variant: "contained",
        color: "primary",
        "data-tour": "complete-lesson",
        className: classNames(s.tabletFullWidth, s.actionButtonWrapper, s.statusBtn, _defineProperty({}, s.completeButtonSuccess, completed || lesson.isCompleted)),
        onClick: completed || lesson.isCompleted ? function () {
          return _this2.toggleLessonReviewContent(true);
        } : this.completeOnce,
        size: "large"
      }, void 0, (lesson.isCompleted || completed) && /*#__PURE__*/_jsx(DoneIcon, {
        className: s.buttonIcon
      }), completed || lesson.isCompleted ? /*#__PURE__*/React.createElement(FormattedMessage, messages.completedBtnMsg) : '', !lesson.isCompleted && !completed ? /*#__PURE__*/React.createElement(FormattedMessage, messages.completeBtnmsg) : ''), nextButtonDesktop))), course._id && /*#__PURE__*/_jsx(Modal, {
        open: isCongratulationsModalOpened,
        onClose: this.closeCongratulationsModal
      }, void 0, /*#__PURE__*/_jsx(CongratulationsModal, {
        onClose: this.closeCongratulationsModal,
        course: course,
        hideCertificateBtn: hasMedicalLicense(auth.user && auth.user.mainGroup) || !course.assignCertificate || isTrial(auth)
      })), isAttachedCoursesByUsersModalOpened && /*#__PURE__*/_jsx(AttachedCoursesModal, {
        onClose: this.closeAttachedCoursesByUsersModal,
        numberOfAttachedCourses: attachedCoursesByUsers,
        lessonId: lesson._id,
        auth: auth
      }), /*#__PURE__*/_jsx(Snackbar, {
        open: !!errorSnackbarMsg,
        onClose: this.handleCloseErrorSnackbar,
        autoHideDuration: 2000,
        message: errorSnackbarMsg
      }), goToNextSectionItemProgress !== 0 && nextItem && /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx(GoToNextSection, {
        nextItem: nextItem,
        nextPath: nextPath,
        goToNextSectionItemProgress: goToNextSectionItemProgress,
        cancelGoToNextSectionItem: this.cancelGoToNextSectionItem,
        nextPodcastItemClickHandler: this.loadNextItem,
        isPodcastStyle: true
      })));
    }
  }]);
  return LessonDetails;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  query: {},
  courseSlug: undefined,
  posterVimeo: '',
  completeLessonError: null,
  searchSessionId: ''
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class);
export { LessonDetails as default };